<script setup>
import { ref } from 'vue';
import TheTopBar from './components/TheTopBar.vue';
import TheHeader from './components/TheHeader.vue';
import HeroSection from './components/HeroSection.vue';
import WhyChooseUsSection from './components/WhyChooseUsSection.vue';
import AboutUsSection from './components/AboutUsSection.vue';

import VideoTutorialSection from './components/VideoTutorialSection.vue';
import PopularCoursesSection from './components/PopularCoursesSection.vue';
import StatisticsBanner from './components/StatisticsBanner.vue';
import UpcomingEventsSection from './components/UpcomingEventsSection.vue';
import InquirySection from './components/InquirySection.vue';
import TeachersSection from './components/TeachersSection.vue';
import TestimonialsSection from './components/TestimonialsSection.vue';
import BlogSection from './components/BlogSection.vue';
import Footer from './components/Footer.vue'
import Principle from './components/Principle.vue'
import Campuses from './components/Campuses.vue'

const heroFeatures = ref([
  { icon: 'GraduationCap', title: 'Scholarship', color: 'bg-pink-red' },
  { icon: 'BookOpen', title: '2500+ Courses', color: 'bg-bright-green' },
  { icon: 'Award', title: 'Admission', color: 'bg-bright-yellow' },
  { icon: 'Globe', title: 'Global exposure', color: 'bg-light-blue' },
  { icon: 'Book', title: 'academics', color: 'bg-pink-red' },
]);


const facultyDepartments = ref([
  { title: 'Faculty Of Pharmacy', description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text', color: 'bg-pink-red' },
  { title: 'Faculty Of Computer Science', description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text', color: 'bg-bright-green' },
  { title: 'Faculty Of Design', description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text', color: 'bg-bright-yellow' },
]);

const popularCourses = ref([
  {
    image: '/placeholder.svg?height=200&width=300',
    title: 'Nullam id varius nunc id varius nunc',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text',
    rating: 5,
    students: 31,
    views: 10,
    instructorAvatar: '/placeholder.svg?height=40&width=40',
    instructorName: 'Alia Noor',
    price: 'Free'
  },
  {
    image: '/placeholder.svg?height=200&width=300',
    title: 'Nullam id varius nunc id varius nunc',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text',
    rating: 5,
    students: 31,
    views: 10,
    instructorAvatar: '/placeholder.svg?height=40&width=40',
    instructorName: 'Dany Core',
    price: '$49'
  },
  {
    image: '/placeholder.svg?height=200&width=300',
    title: 'Nullam id varius nunc id varius nunc',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text',
    rating: 5,
    students: 31,
    views: 10,
    instructorAvatar: '/placeholder.svg?height=40&width=40',
    instructorName: 'Smith Parker',
    price: 'Free'
  },
  {
    image: '/placeholder.svg?height=200&width=300',
    title: 'Nullam id varius nunc id varius nunc',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text',
    rating: 5,
    students: 31,
    views: 10,
    instructorAvatar: '/placeholder.svg?height=40&width=40',
    instructorName: 'Sara Robert',
    price: '$54'
  },
  {
    image: '/placeholder.svg?height=200&width=300',
    title: 'Nullam id varius nunc id varius nunc',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text',
    rating: 5,
    students: 31,
    views: 10,
    instructorAvatar: '/placeholder.svg?height=40&width=40',
    instructorName: 'Wendy Nahse',
    price: '$36'
  },
  {
    image: '/placeholder.svg?height=200&width=300',
    title: 'Nullam id varius nunc id varius nunc',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text',
    rating: 5,
    students: 31,
    views: 10,
    instructorAvatar: '/placeholder.svg?height=40&width=40',
    instructorName: 'John Wood',
    price: '$22'
  },
]);

const statistics = ref([
  { icon: 'Users', count: '1800+', label: 'Students' },
  { icon: 'BookOpen', count: '70', label: 'Courses' },
  { icon: 'User', count: '700+', label: 'Certified Teachers' },
  { icon: 'Award', count: '1200+', label: 'Award Winning' },
]);

const upcomingEvents = ref([
  {
    date: '27 Apr',
    time: '9:00 AM - 4:00 PM',
    title: 'Nullam id varius nunc id varius nunc',
    instructor: 'John Wood',
    location: 'New York City',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text'
  },
  {
    date: '22 Jun',
    time: '11:00 AM - 4:00 PM',
    title: 'Nullam id varius nunc id varius nunc',
    instructor: 'John Wood',
    location: 'New York City',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text'
  },
  {
    date: '16 May',
    time: '10:00 AM - 3:00 PM',
    title: 'Nullam id varius nunc id varius nunc',
    instructor: 'John Wood',
    location: 'New York City',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text'
  },
  {
    date: '22 Jun',
    time: '11:00 AM - 4:00 PM',
    title: 'Nullam id varius nunc id varius nunc',
    instructor: 'John Wood',
    location: 'New York City',
    description: 'If you are going to use a passage of Lorem Ipsum, you need to be sure there isn\'t anything embarrassing hidden in the middle of text'
  },
]);

const teachers = ref([
  { image: '/placeholder.svg?height=150&width=150', name: 'Aden Smith', title: 'Head Of Department' },
  { image: '/placeholder.svg?height=150&width=150', name: 'Kally Brooks', title: 'Professor' },
  { image: '/placeholder.svg?height=150&width=150', name: 'David Clark', title: 'Chemistry Teacher' },
  { image: '/placeholder.svg?height=150&width=150', name: 'Rebeka Alig', title: 'English Teacher' },
]);

const testimonials = ref([
  { image: '/placeholder.svg?height=80&width=80', name: 'Lissa Castro', title: 'Co-Founder', quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaeillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.' },
  { image: '/placeholder.svg?height=80&width=80', name: 'Lissa Castro', title: 'Co-Founder', quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaeillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.' },
  { image: '/placeholder.svg?height=80&width=80', name: 'Lissa Castro', title: 'Co-Founder', quote: 'Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, quaeillo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.' },
]);

const blogPosts = ref([
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '15 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '23 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '16 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '15 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '23 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '16 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '15 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '23 May, 2019', comments: 2 },
  { image: '/placeholder.svg?height=200&width=300', title: 'Why are tickets to fly to Lagos expensive?', date: '16 May, 2019', comments: 2 },
]);

const isMobileMenuOpen = ref(false);

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
</script>

<template>
  <div class="font-sans text-text-dark">
    <TheTopBar />
    <TheHeader  />
    <HeroSection :heroFeatures="heroFeatures" />
    <WhyChooseUsSection  />
    <AboutUsSection />
   
    <!-- <VideoTutorialSection /> -->
    <PopularCoursesSection :popularCourses="popularCourses" />
    <StatisticsBanner :statistics="statistics" />
    <UpcomingEventsSection :upcomingEvents="upcomingEvents" />
    <Principle/>
    <Campuses/>
    <InquirySection />
    <TeachersSection :teachers="teachers" />
    <TestimonialsSection :testimonials="testimonials" />
    <!-- <BlogSection :blogPosts="blogPosts" /> -->
    <Footer />
  </div>
</template>

<style>
/* Global styles or base animations can go here if needed */
@keyframes fade-in-up {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fade-in-up 0.6s ease-out forwards;
  opacity: 0; /* Start hidden */
}

.animate-fade-in-up.delay-100 {
  animation-delay: 0.1s;
}

.animate-fade-in-up.delay-200 {
  animation-delay: 0.2s;
}
</style>
